<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.dataDesejadaEspecialidades"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(especialidade) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a especialidade?',
                async () => this.data.model.dataDesejadaEspecialidades
                    .splice(this.data.model.dataDesejadaEspecialidades.indexOf(especialidade), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>